import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';
import { motion } from 'framer-motion';
import { toast } from 'react-toastify';
import api from '../../utils/api';

function LeaveBalance() {
  const [leaveBalance, setLeaveBalance] = useState({
    totalLeavesTaken: '',
    earnedLeaves: '',
    sickLeaves: '',
    compOffs: ''
  });

  const { empid } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLeaveBalance = async () => {
      try {
        const response = await api.get(`/leaveBalance/${empid}`);
        setLeaveBalance(response.data);
      } catch (error) {
        console.error("Error fetching leave balance:", error);
        toast.error("Failed to fetch leave balance");
      }
    };

    fetchLeaveBalance();
  }, [empid]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLeaveBalance((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.put(`/leaveBalance/${empid}`, leaveBalance);
      setLeaveBalance(response.data);
      toast.success('Leave balance updated successfully');
      navigate(-1);
    } catch (error) {
      console.error("Error updating leave balance:", error);
      toast.error('Failed to update leave balance');
    }
  };

  const fields = [
    { label: 'Total Leaves Taken', name: 'totalLeavesTaken', placeholder: 'Total leaves taken' },
    { label: 'Earned Leaves', name: 'earnedLeaves', placeholder: 'Remaining earned leaves' },
    { label: 'Sick Leaves', name: 'sickLeaves', placeholder: 'Remaining sick leaves' },
    { label: 'Comp Offs', name: 'compOffs', placeholder: 'Available comp offs' },
  ];

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <motion.div 
        className="text-center mb-10"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1 className="text-3xl md:text-4xl font-bold text-slate-800">
          Update Leave Balance
        </h1>
        <p className="text-slate-500 mt-2">Modify and save the latest leave data.</p>
      </motion.div>

      <motion.form 
        onSubmit={handleSubmit}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 bg-white p-6 rounded-2xl shadow-md"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.1 }}
      >
        {fields.map(({ label, name, placeholder }) => (
          <div key={name}>
            <label className="block text-sm font-medium text-slate-600 mb-1">
              {label}
            </label>
            <input
              type="number"
              name={name}
              placeholder={placeholder}
              value={leaveBalance[name] || ''}
              onChange={handleInputChange}
              className="w-full rounded-xl border border-slate-300 px-4 py-2 focus:ring-2 focus:ring-slate-500 focus:outline-none shadow-sm transition duration-200"
            />
          </div>
        ))}

        <div className="col-span-1 sm:col-span-2 lg:col-span-4">
          <button
            type="submit"
            className="w-full mt-4 bg-slate-800 text-white py-3 rounded-xl font-medium text-lg hover:bg-slate-700 transition-transform transform hover:scale-[1.02] active:scale-95 shadow-md"
          >
            Save Changes
          </button>
        </div>
      </motion.form>
    </div>
  );
}

export default LeaveBalance;
